const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    wishlist: localStorage.getItem("wishlist")
        ? JSON.parse(localStorage.getItem("wishlist"))
        : [],
}

const wishlistSlice = createSlice({
    name: "wishlist",
    initialState,
    reducers: {
        addToWishList: (state, action) => {
            const item = state.wishlist.find((item) => item._id === action.payload._id);
            
            if (item) {
                state.wishlist = state.wishlist.filter((item) => item._id !== action.payload._id);
            }
            else{
                state.wishlist.push(action.payload);
                
            }
            localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
        },
    },
});

export default wishlistSlice.reducer;
export const { addToWishList } = wishlistSlice.actions;